/* import __COLOCATED_TEMPLATE__ from './pii-attribute-masking.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import type SecurityAppSettings from 'embercom/models/security-app-settings';

interface Args {
  settings: SecurityAppSettings;
}

interface Signature {
  Args: Args;
}

export default class PiiAttributeMasking extends Component<Signature> {
  get isMaskingEnabled(): boolean {
    return this.args.settings.piiAttributeMaskingEnabled ?? false;
  }

  get isEmailMaskingEnabled(): boolean {
    return this.args.settings.piiEmailMaskingEnabled ?? false;
  }

  get isPhoneMaskingEnabled(): boolean {
    return this.args.settings.piiPhoneMaskingEnabled ?? false;
  }

  @action
  toggleMasking() {
    let newValue = !this.isMaskingEnabled;
    this.args.settings.set('piiAttributeMaskingEnabled', newValue);

    if (newValue && !this.isEmailMaskingEnabled && !this.isPhoneMaskingEnabled) {
      // Turning master ON with both sub-toggles OFF → both default to ON
      this.args.settings.set('piiEmailMaskingEnabled', true);
      this.args.settings.set('piiPhoneMaskingEnabled', true);
    }

    if (!newValue) {
      this.args.settings.set('piiEmailMaskingEnabled', false);
      this.args.settings.set('piiPhoneMaskingEnabled', false);
    }
  }

  @action
  toggleEmailMasking() {
    let newValue = !this.isEmailMaskingEnabled;
    this.args.settings.set('piiEmailMaskingEnabled', newValue);

    // If both sub-toggles are now off, disable master
    if (!newValue && !this.isPhoneMaskingEnabled) {
      this.args.settings.set('piiAttributeMaskingEnabled', false);
    }
  }

  @action
  togglePhoneMasking() {
    let newValue = !this.isPhoneMaskingEnabled;
    this.args.settings.set('piiPhoneMaskingEnabled', newValue);

    // If both sub-toggles are now off, disable master
    if (!newValue && !this.isEmailMaskingEnabled) {
      this.args.settings.set('piiAttributeMaskingEnabled', false);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Security::Tabs::PiiAttributeMasking': typeof PiiAttributeMasking;
    'new-settings/workspace/security/tabs/pii-attribute-masking': typeof PiiAttributeMasking;
  }
}
